import React from 'react';
import PropTypes from 'prop-types';
import { useSmartSearchContext } from '../../../context/smartSearch';

import Typography, {
  TypographyWeights,
} from '../../../ui-components/Typography/Typography';
import Button, { ButtonStyles, ButtonSizes } from '../../Button/Button';
import BetaIcon, { IconColors, IconSizes } from '../../Icons/Icon';

export default function SmartSearchHeader({ title }) {
  if (!title) return null;

  const { setIsModalOpen } = useSmartSearchContext();

  return (
    <div className="smart-search__container--header">
      <Typography variant="p1" weight={TypographyWeights['semi-bold']}>
        {title}
      </Typography>
      <Button
        onClick={setIsModalOpen(false)}
        style={ButtonStyles.text}
        size={ButtonSizes.xs}
        iconRight={
          <BetaIcon
            name={'close'}
            color={IconColors.regular}
            size={IconSizes[12]}
          />
        }
      />
    </div>
  );
}

SmartSearchHeader.propTypes = {
  title: PropTypes.string,
};
